import axios, { AxiosInstance } from "axios";
import { LoginRequest } from "./Models";
import { getStoreValue } from "../utils/utils";

const PARTNER_ID = 'suki-jwt_partnerID'
export class SUKIAPI {
  private static SUKI_INSTANCE: AxiosInstance;

  static initialize() {
    SUKIAPI.SUKI_INSTANCE = axios.create({
      baseURL: process.env.REACT_APP_SUKI_API || '/api', 
    });
  }

  // START AUTH
  static login = async (request: LoginRequest) => {
    if (!SUKIAPI.SUKI_INSTANCE) {
      throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
    }

    const response = await SUKIAPI.SUKI_INSTANCE.post("/login-dashboard", request);
    return response.data;
  }

  static createPassword = async (request: any, accessToken: string) => {
    if (!SUKIAPI.SUKI_INSTANCE) {
      throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
    }

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      }
    };

    const response = await SUKIAPI.SUKI_INSTANCE.post("/change-password", request, config);
    return response.data;
  }
  // END AUTH

  // START PARTNERS
  static uploadPartnersAwardFile = async (request: File, accessToken: string) => {
    const partnerId = await getStoreValue(PARTNER_ID);
  
    const URL = `/rewards/batches/${partnerId}`;
    if (!SUKIAPI.SUKI_INSTANCE) {
      throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
    }
  
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      }
    };
  
    const formData = new FormData();
    formData.append('upload.csv', request, request.name); // Use 'upload.csv' as the field name
  
    try {
      const response = await SUKIAPI.SUKI_INSTANCE.post(URL, formData, config);
  
      // Handle the response or any other logic here
      return response.data;
    } catch (error) {
      console.error("File upload error:", error);
      throw error;
    }
  }

  static downloadPartnersReports = async (date: any, accessToken: string) => {
    const partnerId = await getStoreValue(PARTNER_ID);
    const URL = `/rewards/reports/default?from=${date.from}&to=${date.to}`;
    if (!SUKIAPI.SUKI_INSTANCE) {
      throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
    }
  
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'text/csv',
        'X-PARTNER-ID': partnerId,
        Accept: 'text/csv',
      }
    };
  
    const response = await SUKIAPI.SUKI_INSTANCE.get(URL, config);

    return response.data;
  } 


  static getPartnersRecentUploads = async (accessToken: string) => {
    const partnerId = await getStoreValue(PARTNER_ID);
    const URL = `/rewards/batches/${partnerId}?page=1`;
    if (!SUKIAPI.SUKI_INSTANCE) {
      throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
    }
  
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      }
    };
  
    const response = await SUKIAPI.SUKI_INSTANCE.get(URL, config);

    return response.data;
  } 

  static getPartnersTransactions = async (accessToken: string) => {
    const partnerId = await getStoreValue(PARTNER_ID);
    const URL = `/rewards/transactions?page=1&limit=100`;

    if(!partnerId || !accessToken) {
      return
    } else {
      if (!SUKIAPI.SUKI_INSTANCE) {
        throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
      }
  
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'X-PARTNER-ID': partnerId
        }
      };
    
      const response = await SUKIAPI.SUKI_INSTANCE.get(URL, config);
  
      return response.data;
    }
  }

  static getListOfPartners = async (accessToken: string) => {
    const URL = `/rewards/partners`;
    if (!SUKIAPI.SUKI_INSTANCE) {
      throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
    }

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      }
    };
  
    const response = await SUKIAPI.SUKI_INSTANCE.get(URL, config);

    return response.data;
  }

  static getPartnersPointsValues = async (accessToken: string) => {
    const partnerId = await getStoreValue(PARTNER_ID);
    const URL = `/rewards/points`;
    if (!SUKIAPI.SUKI_INSTANCE) {
      throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
    }
  
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        'X-PARTNER-ID': partnerId
      }
    };
  
    const response = await SUKIAPI.SUKI_INSTANCE.get(URL, config);

    return response.data;
  }
  // END PARTNERS

  // START OPERATIONS
  static uploadOperationsAwardFile = async (partnerId:  string, request: File, accessToken: string) => {
    const URL = `/rewards/batches/${partnerId}`;
    if (!SUKIAPI.SUKI_INSTANCE) {
      throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
    }
  
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      }
    };
  
    const formData = new FormData();
    formData.append('upload.csv', request, request.name); // Use 'upload.csv' as the field name
  
    try {
      const response = await SUKIAPI.SUKI_INSTANCE.post(URL, formData, config);
  
      // Handle the response or any other logic here
      return response.data;
    } catch (error) {
      console.error("File upload error:", error);
      throw error;
    }
  }

  static getOperationsRecentUploads = async (accessToken: string) => {
    const URL = `/rewards/batches?page=1`;
    if (!SUKIAPI.SUKI_INSTANCE) {
      throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
    }
  
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      }
    };
  
    const response = await SUKIAPI.SUKI_INSTANCE.get(URL, config);

    return response.data;
  } 

  static getOperationsTransactions = async (accessToken: string) => {
    const URL = `/rewards/transactions?page=1&limit=100`;
    if (!SUKIAPI.SUKI_INSTANCE) {
      throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
    }
  
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      }
    };
  
    const response = await SUKIAPI.SUKI_INSTANCE.get(URL, config);

    return response.data;
  }

  static getOperationsPointsValues = async (accessToken: string) => {
    const URL = `/rewards/points`;
    if (!SUKIAPI.SUKI_INSTANCE) {
      throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
    }
  
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      }
    };
  
    const response = await SUKIAPI.SUKI_INSTANCE.get(URL, config);

    return response.data;
  }


  static downloadOperationsReports = async (date: any, partnerId: any, accessToken: string) => {
    const URL = `/rewards/reports/default?from=${date.from}&to=${date.to}`;
    if (!SUKIAPI.SUKI_INSTANCE) {
      throw new Error("SUKI_INSTANCE is not initialized. Call SUKIAPI.initialize() before making requests.");
    }
  
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'text/csv',
        'X-PARTNER-ID': partnerId,
        Accept: 'text/csv',
      }
    };
  
    const response = await SUKIAPI.SUKI_INSTANCE.get(URL, config);

    return response.data;
  } 
  // END OPERATIONS
}

// Initialize the SUKIAPI instance
SUKIAPI.initialize();
